import { FC, useState, useRef, CSSProperties, PropsWithChildren } from 'react'
import Button from 'components/Button'
import FeatureItem, {
  TProps as TFeatureItemProps,
} from 'components/FeatureItem'
import classNames from 'classnames'
import { toCurrency } from 'lib/number'
import { IconCircleMoneySign } from 'icons'
import styles from './ValueBox.module.scss'

type TProps = {
  price: number
  featureList?: Array<TFeatureItemProps>
  onClick?: () => void
  onExpand?: () => void
}

const ValueBox: FC<PropsWithChildren<TProps>> = ({
  price,
  featureList = [],
  onClick,
  onExpand,
  children,
}) => {
  const [open, setOpen] = useState(false)
  const listRef = useRef<HTMLDivElement>(null)
  const listHeight = listRef?.current?.offsetHeight

  const className = classNames(styles.ecValueBox)
  const buttonTitle = open ? 'Esconder valores' : 'Mostrar valores'

  return (
    <div className={styles.ecValueBoxContainer}>
      {children}
      <div className={className}>
        <button
          aria-hidden
          aria-label={buttonTitle}
          className={styles.ecValueBoxButton}
          onClick={() => {
            setOpen(!open)
            if (onExpand && !open) onExpand()
          }}
        />
        <div className={styles.ecValueBoxHeader}>
          <div className={styles.ecValueBoxHeaderContainer}>
            <p className={styles.ecValueBoxHeaderPriceContainer}>
              Compre por
              <strong className={styles.ecValueBoxHeaderPrice}>
                {toCurrency(price)}
              </strong>
            </p>
            <a
              href="#detalhes-do-pagamento"
              className={styles.ecValueBoxHeaderLink}
            >
              <IconCircleMoneySign
                width={24}
                height={24}
                color="pink500"
                title="Ícone: cifrão"
              />
              Ver pagamento
            </a>
            <button
              aria-hidden
              aria-label={buttonTitle}
              className={styles.ecValueBoxHeaderButton}
              onClick={() => {
                setOpen(!open)
                if (onExpand && !open) onExpand()
              }}
            />
          </div>
          <Button theme="pink" onClick={onClick}>
            Agendar visita
          </Button>
        </div>
        {featureList.length > 0 && (
          <div
            id="detalhes-do-pagamento"
            className={styles.ecValueBoxListWrapper}
            style={
              {
                '--height': open && listHeight ? `${listHeight}px` : '0px',
              } as CSSProperties
            }
          >
            <div ref={listRef} className={styles.ecValueBoxList}>
              {featureList?.map((item) => (
                <FeatureItem key={item.title} {...item} />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default ValueBox
